import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var KeyboardDoubleArrowLeft = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
  }));
});
KeyboardDoubleArrowLeft.displayName = 'KeyboardDoubleArrowLeft';
export var KeyboardDoubleArrowLeftDimensions = {
  height: 24,
  width: 24
};